export default [
    {
        path: '/gameDetails',
        name: 'gameDetails',
        meta: {page:"moreGame"},
        component: () => import('@/views/GameDetails'),
    },
    {
        path: '/makeComment',
        name: 'makeComment',
        meta: {page:"moreGame"},
        component: () => import('@/views/GameDetails/makeComment.vue'),
    },
    {
        path: '/voucher',
        name: 'voucher',
        meta: {page:"moreGame"},
        component: () => import('@/views/GameDetails/voucher.vue'),
    },
    {
        path: '/package',
        name: 'package',
        meta: {page:"moreGame"},
        component: () => import('@/views/GameDetails/package.vue'),
    },
    {
        path: '/strategyDetail',
        name: 'strategyDetail',
        meta: {page:"moreGame"},
        component: () => import('@/views/GameDetails/strategyDetail.vue'),
    },
    {
        path: '/rulePage',
        name: 'rulePage',
        meta: {page:"moreGame"},
        component: () => import('@/views/GameDetails/rulePage.vue'),
    },
    {
        path: '/vipPackage',
        name: 'vipPackage',
        meta: {page:"moreGame"},
        component: () => import('@/views/GameDetails/vipPackage.vue'),
    }
]